export interface IDropdownOption {
    value: string;
    label: string;
  }


export const USER_TYPES: IDropdownOption[] = [
    {
      label: 'Journalist',
      value: 'journalist'
    },
    {
      label: 'Non-Profit Professional',
      value: 'non-profit_professional'
    },
    {
      label: 'Student',
      value: 'student'
    },
    {
      label: 'Researcher',
      value: 'researcher'
    },
    {
      label: 'Industry',
      value: 'industry'
    },
    {
      label: 'Other',
      value: 'other'
    }
  ];



  export const PROFICIENCY_LEVELS: IDropdownOption[] = [
    {
      label: 'Beginner',
      value: 'beginner'
    },
    {
      label: 'Intermediate',
      value: 'intermediate'
    },
    {
      label: 'Advanced',
      value: 'advanced'
    },
    {
      label: 'Expert',
      value: 'expert'
    }
  ];
  
  export const FREQUENCY_OPTIONS: IDropdownOption[] = [
    {
      label: 'Daily',
      value: 'daily'
    },
    {
      label: 'Weekly',
      value: 'weekly'
    },
    {
      label: 'Monthly',
      value: 'monthly'
    },
    {
      label: 'Rarely',
      value: 'rarely'
    }
  ];
  
  export const TOPICS_OF_INTEREST: IDropdownOption[] = [
    {
      label: 'Housing',
      value: 'housing'
    },
    {
      label: 'Transportation',
      value: 'transportation'
    },
    {
      label: 'Energy',
      value: 'energy'
    },
    {
      label: 'Education',
      value: 'education'
    },
    {
      label: 'Health',
      value: 'health'
    },
    {
      label: 'Governance',
      value: 'governance'
    }
  ];
  
  export const REFERRAL_SOURCES: IDropdownOption[] = [
    {
      label: 'Search Engine',
      value: 'search_engine'
    },
    {
      label: 'Social Media',
      value: 'social_media'
    },
    {
      label: 'Another Website',
      value: 'another_website'
    },
    {
      label: 'Event',
      value: 'event'
    },
    {
      label: 'Referral',
      value: 'referral'
    },
    {
      label: 'Other',
      value: 'other'
    }
  ];
  
  export const ORGANIZATIONS: IDropdownOption[] = [
    {
      label: 'Government Agency',
      value: 'government_agency'
    },
    {
      label: 'Non-Profit Organization',
      value: 'non_profit_organization'
    }
  ];

  export const JOB_TITLES: IDropdownOption[] = [
    {
      label: 'Data Analyst',
      value: 'data_analyst'
    },
    {
      label: 'Researcher',
      value: 'researcher'
    },
    {
      label: 'Journalist',
      value: 'journalist'
    }
  ];